<template>
  <div>
    <el-card shadow="always">
      <el-button size="small" type="primary" @click="saveDialog()" v-if="$isPerm('position-save')">添加</el-button>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
    </el-card>
    <el-table height="600" size="small" :data="tableData" border :default-expand-all="true" row-key="id" class="box-card mt10">
      <el-table-column prop="name" label="职位名称" width="180"> </el-table-column>
      <el-table-column prop="employee_qty" label="员工数" width="80"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="permsDialog(scope.row)" v-if="$isPerm('position-auth-update')">权限</el-button>
          <el-button size="mini" type="primary" @click="saveDialog(scope.row)" v-if="$isPerm('position-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="delData(scope.row.id)" v-if="$isPerm('position-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <div style="padding: 20px">
        <el-form size="small" ref="formRef" :model="formData" label-width="120px">
          <el-form-item label="职位名称" prop="name">
            <el-input v-model="formData.name" style="width: 220px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-but">
        <el-button type="primary" :loading="loading" @click="saveData()">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="permsTitle" :visible.sync="permsShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <perms ref="permsRef" @callMethod="refresh"></perms>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import perms from '@/components/position/perms.vue';
export default {
  name: 'employeePositionList',
  components: {
    perms
  },
  created() {
    this.getData();
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      permsTitle: '',
      permsShow: false,
      loading: false,
      tableData: [],
      formData: {
        id: 0,
        name: ''
      }
    };
  },
  methods: {
    async getData() {
      await this.$api.position.list().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ?? [];
        }
      });
    },
    // 权限弹窗
    permsDialog(row) {
      this.permsShow = true;
      this.permsTitle = '[' + row.name + ']权限设置';
      this.$nextTick(() => {
        this.$refs.permsRef.setData(row.id);
      });
    },

    // 添加、编辑弹窗
    saveDialog(row) {
      this.formData = {
        id: 0,
        name: ''
      };
      this.dialogShow = true;
      this.dialogTitle = '添加职位';
      if (row) {
        this.dialogTitle = '编辑职位';
        this.formData = row;
      }
    },
    // 保存数据
    async saveData() {
      let data = _.cloneDeep(this.formData);
      this.loading = true;
      await this.$api.position.save(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.refresh();
        }
      });
    },
    async delData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.position.delete({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.refresh();
            }
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    refresh() {
      this.dialogShow = false;
      this.permsShow = false;
      this.getData();
    }
  }
};
</script>
